export const PRIVY_OAUTH_CALLBACK_PARAMS = Object.freeze([
  "privy_oauth_code",
  "privy_oauth_state",
  "privy_oauth_provider"
]);

function readCurrentHref() {
  return typeof window === "undefined" ? "" : window.location.href;
}

export function hasPrivyOAuthCallbackParams({ href = readCurrentHref() } = {}) {
  try {
    const url = new URL(href);
    return PRIVY_OAUTH_CALLBACK_PARAMS.some((param) => url.searchParams.has(param));
  } catch {
    return false;
  }
}

export function removePrivyOAuthCallbackParamsFromUrl(href) {
  const url = new URL(href);
  let changed = false;

  for (const param of PRIVY_OAUTH_CALLBACK_PARAMS) {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      changed = true;
    }
  }

  if (!changed) {
    return null;
  }

  return `${url.pathname}${url.search}${url.hash}`;
}

export function cleanupPrivyOAuthCallbackParams({ location = window.location, history = window.history } = {}) {
  const nextPath = removePrivyOAuthCallbackParamsFromUrl(location.href);
  if (!nextPath) {
    return false;
  }

  history.replaceState(history.state, "", nextPath);
  return true;
}
